export interface IFrameInfo {
  i: number
  y: number
  x: number
  h?: number
  w?: number
  frame?: Phaser.Textures.Frame
  scale?: number
}

export interface IRawFrameInfo {
  i: number
  y: number
  x: number
  h: number
  w: number
  frame?: Phaser.Textures.Frame
  scale?: number
}

export function fi32(
  i: number,
  y: number,
  x: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x,
    y,
    i,
    w,
    h,
  }
}

export function fi32run(
  idx: number,
  y: number,
  x: number,
  num: number,
): IFrameInfo[] {
  let frames: IFrameInfo[] = []
  for (let i = 0; i < num; i++) {
    frames.push(fi32(idx, y, x + i))
  }
  return frames
}

export function fAbi(
  i: number,
  y: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x: y,
    y: 0,
    i,
    w,
    h,
  }
}

export function fAbiRun(idx: number, y: number, num: number): IFrameInfo[] {
  let frames: IFrameInfo[] = []
  for (let i = 0; i < num; i++) {
    frames.push(fAbi(idx, y + i))
  }
  return frames
}

export function fiRaw(
  i: number,
  x: number,
  y: number,
  w: number,
  h: number,
): IRawFrameInfo {
  return {
    x,
    y,
    i,
    w,
    h,
  }
}

export function fiMonster(
  y: number,
  x: number,
  h: number = 1,
  w: number = 1,
): IFrameInfo {
  return {
    x,
    y,
    i: 2,
    w,
    h,
  }
}
